import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  AiFillYoutube,
  AiFillFacebook,  
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Container className="footer-inner">
        <Row className="footer-top">
          <Col md={4} className="footer-col">
            <h3 className="footer-heading">Choicest Fruit®, LLC</h3>
          </Col>

          <Col md={4} className="footer-col">
            <h3 className="footer-heading">Contact</h3>
            <div className="footer-item">
              <a className="footer-link" href="mailto:info@choicestfruit.com">
                info@choicestfruit.com
              </a>
            </div>
            <div className="footer-item">Austin, Texas</div>
          </Col>

          <Col md={4} className="footer-col">
            <h3 className="footer-heading">Policies</h3>
            <ul className="footer-links" aria-label="Policies">
              <li>
                <Link className="footer-link" to="/policies/grievance-appeals">
                  Grievance / Appeals Policy
                </Link>
              </li>
              <li>
                <Link className="footer-link" to="/policies/privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link className="footer-link" to="/policies/terms">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col md={6} className="footer-col footer-copyright">
            <div className="footer-item">Copyright © {year} CF</div>
          </Col>
          <Col md={6} className="footer-col footer-social">
            <ul className="footer-icons" aria-label="Social links">
              <li className="social-icons">
                <a
                  href="https://www.youtube.com/@ChoicestFruit"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <AiFillYoutube />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=100083371838989"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/company/choicest-fruit/"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Footer;
